import React from "react";
import { Typography, Box } from "@mui/material";
import { brand } from "../theme";
import PageLayout from "../components/PageLayout";
import ResponsiveImage from "../components/ResponsiveImage";
import ContactInfo from "../components/ContactInfo";

const About: React.FC = () => {
    return (
        <PageLayout title="Wir">
            <Typography variant="body1" color="inherit" sx={{ textAlign: "justify", mb: 4 }}>
                Hallo, wir sind die Werklibuebe. Wir sind ein junges und aufgestelltes Team. Unsere Leidenschaft ist
                das Arbeiten mit dem Werkstoff Holz. Unsere Arbeiten umfassen verschiedenste Dinge von einem kleinen
                Schneidebrett über Möbel bis hin zu Gartenhäusern. Ob mit Plattenmaterialien oder Massivholz ganz
                nach Ihren Wünschen. Wir fräsen und lasern Ihre Logos und Bilder, sei es für Firmen, als Geschenk
                oder für den Eigenbedarf. Beim Bearbeiten unseres Holzes achten wir auf eine möglichst regionale
                Herkunft und kurze Transportwege.
            </Typography>

            <Typography variant="h6" gutterBottom sx={{ color: brand.orange }}>
                Gerne verwirklichen wir auch Ihre Träume aus Holz. Melden Sie sich unter:
            </Typography>

            <ContactInfo />

            <Typography variant="h4" gutterBottom align="center" sx={{ color: brand.orange, mt: 6 }}>
                Entstehung
            </Typography>

            <Typography variant="body1" color="inherit" sx={{ textAlign: "justify", mb: 4 }}>
                Werklibuebe entstand im Jahr 2020, als wir ein tolles Projekt, an dem wir gearbeitet hatten,
                rückbauen mussten. Da für uns Nichtstun keine Option ist, suchten wir eine neue Beschäftigung. Wir
                kamen an etwas Restholz vom Bau einer Terrasse, das übrig geblieben war. Mit wenig Platz und noch
                nicht allzu guten Maschinen produzierten wir im Hobbyraum von Severin unser erstes Produkt:
                Klappstühle und Handyhalter. Schon seit klein auf haben wir Dinge an der Strasse verkauft, also
                taten wir das Gleiche auch mit den Stühlen.
            </Typography>

            <Box sx={{ maxWidth: 640, mx: "auto", mb: 4 }}>
                <ResponsiveImage
                    src="/img/folding_chairs.png"
                    alt="Klappstühle"
                    sizes="(max-width: 640px) 100vw, 640px"
                    sx={{ borderRadius: 2, boxShadow: 3 }}
                />
            </Box>

            <Typography variant="body1" color="inherit" sx={{ textAlign: "justify", mb: 4 }}>
                Es lief ziemlich gut, und schon bald bekamen wir unsere ersten Aufträge. Wir wurden auch an den
                Kreativmarkt in Brütten eingeladen, der jährlich stattfindet. Somit haben wir einen guten Ort
                gefunden, um uns zu präsentieren. Innerhalb von zwei Jahren änderte sich so viel. Wir haben mehr
                Aufträge bekommen, was uns sehr erfreut. Ebenso haben wir eine neue Werkstatt mit 65 m² gefunden, in
                die wir dann umgezogen sind. Zudem ist Joel zu uns gestossen, und somit haben wir ein ziemlich
                erfolgreiches Jahr hinter uns gehabt. Wir haben angefangen, uns ein wenig mit dem Rundholzeinkauf zu
                befassen, sodass wir unser Holz grösstenteils selbst besorgen. Aktuell sind wir immer noch in dieser
                Werkstatt, aber stets auf der Suche nach etwas Neuem. Unser Team ist ebenfalls noch ein wenig
                gewachsen, mit fünf Personen sind wir auf einem guten Weg, mit viel Freude und Leidenschaft eine
                eigene Firma aufzubauen. Wir konnten viele Erfolge feiern und hoffen auf viele weitere grossartige
                Erfolge.
            </Typography>
        </PageLayout>
    );
};

export default About;
